<template>
  <header class="page-header" id="navbar">
    <div class="logo">
      <a @click="scrollTo('landing')">
        <img src="../assets/images/haarlem_logo.svg" alt="haarlem-logo">
      </a>
    </div>
    <input type="checkbox" id="nav-toggle" class="nav-toggle">
    <!-- main nav -->
    <nav v-if="currentPage.includes('Home')">
      <ul class="nav-links">
        <li>
          <a @click="scrollTo('home')">Über uns</a>
        </li>
        <li>
          <a @click="scrollTo('booking')">Termin buchen</a>
        </li>
        <li>
          <a @click="scrollTo('salon')">Salon</a>
        </li>
        <li>
          <a @click="scrollTo('partner')">Partner</a>
        </li>
        <li>
          <a @click="scrollTo('summary')">Kontakt & Anfahrt</a>
        </li>
      </ul>
    </nav>
    <!-- back to home -->
    <nav
        v-if="currentPage.includes('Impressum') || currentPage.includes('Datenschutz') || currentPage.includes('Cosmetics')">
      <ul class="nav-links">
        <li>
          <router-link v-on:click.native="closeMenu" to="/">Zurück zur Startseite</router-link>
        </li>
      </ul>
    </nav>
    <label for="nav-toggle" class="nav-toggle-label">
      <div class="burger-menu">
        <span></span>
      </div>
    </label>
    <div class="social-links">
      <ul>
        <li>
          <a href="https://www.instagram.com/haarlemfriseurehamburg/" target="_blank">
            <i class="fab fa-instagram-square" aria-hidden="true"></i>
          </a>
        </li>
        <li>
          <a href="https://www.facebook.com/haarlemfriseure" target="_blank">
            <i class="fab fa-facebook-square" aria-hidden="true"></i>
          </a>
        </li>
      </ul>
    </div>
  </header>

</template>

<script>

export default {
  name: "Navigation",
  computed: {
    currentPage() {
      return this.$route.name;
    }
  },
  methods: {
    scrollTo(element) {
      // get height of header
      let header = document.getElementById('navbar').offsetHeight;
      document.getElementById('nav-toggle').checked = false;

      if (this.$route.name !== 'Home') return;

      let topOfElement = document.getElementById(element).offsetTop - header;
      window.scroll({top: topOfElement, behavior: "smooth"});
    },
    closeMenu() {
      document.getElementById('nav-toggle').checked = false;
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/scss/imports';

$header-height: 150px;
$header-height-md: 130px;
$header-height-sm: 100px;

.page-header {
  position: fixed;
  width: 100%;
  height: $header-height;
  top: 0;
  left: 0;
  background-color: white;
  text-align: center;
  box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.2);
  z-index: 100;

  @include media-breakpoint-down(md) {
    height: $header-height-md;
  }

  .logo {
    position: absolute;
    top: 30%;
    left: 49%;
    transform: translate(-50%, -50%);
    cursor: pointer;

    img {
      width: 320px;

      @include media-breakpoint-down(md) {
        width: 290px;
      }

      @include media-breakpoint-down(sm) {
        width: 270px;
      }

      @include media-breakpoint-down(sm) {
        width: 250px;
      }
    }
  }

  nav {
    position: absolute;
    text-align: center;
    width: 100%;
    top: 85%;
    left: 50%;
    transform: translate(-50%, -50%);

    ul {
      list-style: none;

      li {
        position: relative;
        display: inline-block;
        margin: 0 40px;
        cursor: pointer;
        overflow: hidden;

        @include media-breakpoint-down(md) {
          margin: 28px 28px;
        }

        a {
          color: $black;
          font-size: 16px;
          font-weight: 300;
          text-decoration: none;
          text-transform: uppercase;
          letter-spacing: 2px;
          opacity: 0.75;

          @include media-breakpoint-down(md) {
            font-size: 13px;
          }

          /* Link hover */
          &:before, &:after {
            content: '';
            position: absolute;
            width: 100%;
            height: 2px;
            left: -1px;
            background: $black;
            opacity: 0;
            @include transition;
          }

          &:before {
            bottom: 3px;
            transform: translateX(-100%);
          }

          &:after {
            top: 0;
            transform: translateX(100%);
          }

          &:hover {
            opacity: 1;

            &:before, &:after {
              opacity: 1;
              transform: translateX(0);
            }
          }
        }
      }
    }
  }

  .nav-toggle {
    display: none;
  }

  .nav-toggle-label {
    display: none;
  }

  .social-links {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 93%;
    transform: translate(-50%, -50%);

    ul {
      list-style: none;

      li {
        position: relative;
        display: inline-block;
        margin: 0 4px;

        a {
          font-size: 25px;
          color: $black;

          @include media-breakpoint-down(sm) {
            font-size: 22px;
          }
        }
      }
    }
  }
}

// Burger Menu
@include media-breakpoint-down(sm) {

  .page-header {
    height: $header-height-sm;

    nav {
      position: absolute;
      width: 100%;
      top: 100%;
      left: auto;
      background: $white;
      border-bottom: 1px solid;
      border-color: ghostwhite;
      padding-top: 10px;
      padding-bottom: 10px;
      transform-origin: top;
      transform: scale(1, 0);
      @include transition;
      z-index: -1;
      overflow: hidden;

      @include media-breakpoint-down(xs) {
        width: 100%;
        left: auto;
      }

      ul {
        li {
          display: block;

          a {
            opacity: 0;
            font-size: 15px;
            transition: opacity 100ms ease-in-out;
          }
        }
      }
    }

    .nav-toggle {
      position: absolute;
      display: none;
    }

    .nav-toggle:checked ~ nav {
      transform: scale(1, 1);

      a {
        opacity: 1;
        transition: opacity 150ms ease-in-out 150ms;
      }
    }

    .nav-toggle-label {
      position: absolute;
      display: block;
      top: 70%;
      left: 50%;
      width: 30px;
      height: 30px;
      transform: translate(-50%, -50%);
      cursor: pointer;

      .burger-menu {
        position: absolute;
        left: 50%;
        top: 70%;
        transform: translate(-50%, -50%);

        /* circle border */
        &:before {
          content: '';
          position: absolute;
          top: -13px;
          left: -7px;
          width: 28px;
          height: 28px;
          border: 2px solid $black;
          border-radius: 50%;
        }

        /* burger menu */
        span, span:before, span:after {
          display: block;
          position: relative;
          background: $black;
          height: 2px;
          width: 14px;
        }

        span {
          &:before, &:after {
            content: '';
            position: absolute;
          }

          &:before {
            bottom: 5px;
          }

          &:after {
            top: 5px;
          }
        }
      }
    }
  }
}
</style>
